export const typeNames = { BR: 'Receipt', BP: 'Payment', CR: 'Cash Receipt', CP: 'Cash Payment', JV: 'Journal' };

// Account of a reconciliation item, prefixed with the flat no for members
export function itemName(item) {
    return item.name ? (item.unit ? item.unit + ' - ' : '') + item.name : 'Journal Voucher';
}
